<template>
    <div class="row d-flex flex-column" style="border-top: 0.125rem solid rgba(1, 153, 209, .5)">
        <common-chart class="h-30 block-cover" :options="gaugeConfig('机加', dataMap['Machine'])"></common-chart>
        <common-chart class="h-30 block-cover mt-1"
                      :options="gaugeConfig('定转子', dataMap['Stator_Rotor'])"></common-chart>
        <common-chart class="h-30 block-cover mt-1" :options="gaugeConfig('缸体', dataMap['Casing'])"></common-chart>
    </div>
</template>

<script>
import CommonChart from "@/components/echarts-part/kpi/stuff/CommonChart.vue";
import {_pxGenerator} from "@/components/LayoutMaps/maps/MapFunction";

export default {
    name: "DeviceDeadRates",
    components: {CommonChart},
    data() {
        return {
            dataMap: [],
            fresh: null
        }
    },
    mounted() {
        this.getDeadRate();
        this.fresh = setInterval(() => {
            this.getDeadRate()
        }, 600000);
    },
    beforeDestroy() {
        clearInterval(this.fresh);
    },
    methods: {
        gaugeConfig(name, value) {
            return {
                series: [
                    {
                        type: 'gauge',
                        startAngle: 180,
                        endAngle: 0,
                        center: ['35%', '75%'],
                        radius: '100%',
                        min: 0,
                        max: 1,
                        splitNumber: 5,
                        axisLine: {
                            lineStyle: {
                                width: _pxGenerator(0.04),
                                color: [
                                    [0.2, '#7CFFB2'],
                                    [0.8, '#FDDD60'],
                                    [1, '#FF6E76'],
                                ]
                            }
                        },
                        pointer: {
                            icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                            length: '20%',
                            width: _pxGenerator(0.12),
                            offsetCenter: [0, '-55%'],
                            itemStyle: {
                                color: 'inherit'
                            }
                        },
                        axisTick: {
                            length: _pxGenerator(0.02),
                            distance: _pxGenerator(0.02),
                            lineStyle: {
                                color: '#eee',
                                width: _pxGenerator(0.01)
                            },
                        },
                        splitLine: {
                            length: _pxGenerator(0.04),
                            distance: _pxGenerator(0.02),
                            lineStyle: {
                                color: '#eee',
                                width: _pxGenerator(0.01)
                            }
                        },
                        axisLabel: {
                            show: false
                        },
                        title: {
                            offsetCenter: ['200%', '-30%'],
                            fontSize: _pxGenerator(0.2),
                            color: 'inherit'
                        },
                        detail: {
                            fontSize: _pxGenerator(0.18),
                            offsetCenter: [0, 0],
                            valueAnimation: true,
                            formatter: function (value) {
                                return (value * 100).toFixed(2) + '%';
                            },
                            color: 'inherit'
                        },
                        data: [
                            {
                                value: value,
                                name: name
                            }
                        ]
                    }
                ]
            }
        },
        getDeadRate() {
            this.$store.dispatch('api/get', {
                url: process.env.VUE_APP_SITHMES_ANDON_URL + "/sithMesAndonTask/machineDeadRate",
                commonErrorHandle: false
            }).then(response => {
                if (response) {
                    this.dataMap = response;
                }
            })
        },
    },
}
</script>

<style scoped>
.block-cover {
    background-color: #111b4e;
    border-radius: 10px;
}
</style>
